import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Farm from './components/farm.vue'
import { useFarmStore } from '@/stores/farm'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const farmStore = useFarmStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Farm, {
    key: _unref(farmStore).farmKey
  }))
}
}

})